function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCameraRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25a7.499 7.499 0 01-7.5-7.5c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5S20.143 25 16 25zM28 7h-5l-1.447-2.895A2.002 2.002 0 0019.764 3h-7.528c-.757 0-1.45.428-1.789 1.105L9 7H4a2 2 0 00-2 2v18a2 2 0 002 2h24a2 2 0 002-2V9a2 2 0 00-2-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12a5.506 5.506 0 00-5.5 5.5c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5S19.033 12 16 12z",
    fill: props.color
  }));
}

export default SvgIconCameraRexFilled;